import React from 'react'

import moment from 'moment'

export default class TimeAllocationTableHeader extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      startDateStr: props.startDateStr,
      endDateStr: props.endDateStr
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      startDateStr: nextProps.startDateStr,
      endDateStr: nextProps.endDateStr
    })
  }

  renderTotalText() {
    return (
      <div
        key={'total'}
        style={{ display: 'flex', flexGrow: 1, minWidth: 64,
          alignItems: 'center', justifyContent: 'flex-end', paddingLeft: 16,
          paddingRight: 16 }}>
        <span
          style={{ fontSize: 13, color: '#82868a' }}>
          Total
        </span>
      </div>
    )
  }

  renderNameText(text, width) {
    return (
      <div
        key={text}
        style={{ display: 'flex', flexShrink: 0, alignItems: 'center',
          paddingLeft: 16, paddingRight: 16, width: width,
          borderTop: '1px solid #e4e7ea', borderLeft: '1px solid #e4e7ea', borderBottom: '1px solid #e4e7ea' }}>
        <span
          style={{ fontSize: 13, color: '#82868a' }}>
          {text}
        </span>
      </div>
    )
  }

  renderDays() {
    const views = []
    const cursor = moment(this.state.startDateStr)
    const endDate = moment(this.state.endDateStr)
    while (cursor.isSameOrBefore(endDate)) {
      const text = cursor.format('ddd DD')
      views.push(
        <div
          key={text}
          style={{ display: 'flex', flexGrow: 0, flexShrink: 0,
            justifyContent: 'center', alignItems: 'center', width: '80px',
            borderRight: '1px solid #e4e7ea' }}>
          <span
            style={{ fontSize: 13, color: '#82868a' }}>
            {text}
          </span>
        </div>
      )
      cursor.add(1, 'days')
    }
    return views
  }

  render() {
    return (
      <div
        key='header'
        style={{ display: 'flex', flexDirection: 'row', height: 40 }}>

        {this.renderNameText('Job', 100)}
        {this.renderNameText('Line Item', 154)}

        <div
          style={{ display: 'flex', flexDirection: 'row', flexGrow: 1,
            border: '1px solid #e4e7ea', borderBottomWidth: 0, backgroundColor: '#fafbfc' }}>
          {this.renderDays()}
          {this.renderTotalText()}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/reports/timeAllocation/TimeAllocationTableHeader.js